import { render, staticRenderFns } from "./VehicleView.vue?vue&type=template&id=b3f1e056"
import script from "./VehicleView.vue?vue&type=script&lang=js"
export * from "./VehicleView.vue?vue&type=script&lang=js"
import style0 from "./VehicleView.vue?vue&type=style&index=0&id=b3f1e056&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports